const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

export const cognitoConfig = {
  authority: trimTrailingSlash(process.env.REACT_APP_COGNITO_AUTHORITY),
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
  domain: trimTrailingSlash(process.env.REACT_APP_COGNITO_DOMAIN),
  redirectUri: process.env.REACT_APP_COGNITO_REDIRECT_URI || "",
  logoutUri: process.env.REACT_APP_COGNITO_LOGOUT_URI || "",
  scope:
    process.env.REACT_APP_COGNITO_SCOPE ||
    "openid email profile cologuard-api/access",
};

export const missingCognitoConfig = Object.entries({
  REACT_APP_COGNITO_AUTHORITY: cognitoConfig.authority,
  REACT_APP_COGNITO_CLIENT_ID: cognitoConfig.clientId,
  REACT_APP_COGNITO_DOMAIN: cognitoConfig.domain,
  REACT_APP_COGNITO_REDIRECT_URI: cognitoConfig.redirectUri,
  REACT_APP_COGNITO_LOGOUT_URI: cognitoConfig.logoutUri,
}).filter(([, value]) => !value);
